/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedSplatRouteImport } from "./routes/_authenticated/$"
import { Route as AuthenticatedApprovalsIndexRouteImport } from "./routes/_authenticated/approvals/index"
import { Route as AuthenticatedChainsIndexRouteImport } from "./routes/_authenticated/chains/index"
import { Route as AuthenticatedChainsChainNameRouteImport } from "./routes/_authenticated/chains/$chainName"
import { Route as AuthenticatedHomeIndexRouteImport } from "./routes/_authenticated/home/index"
import { Route as AuthenticatedProfileIndexRouteImport } from "./routes/_authenticated/profile/index"
import { Route as AuthenticatedSettingsIndexRouteImport } from "./routes/_authenticated/settings/index"
import { Route as AuthenticatedSettingsSettingNameRouteImport } from "./routes/_authenticated/settings/$settingName"
import { Route as AuthenticatedShowcaseIndexRouteImport } from "./routes/_authenticated/showcase/index"
import { Route as AuthenticatedStoresIndexRouteImport } from "./routes/_authenticated/stores/index"
import { Route as AuthenticatedStoresStoreNameRouteImport } from "./routes/_authenticated/stores/$storeName"
import { Route as AuthenticatedTasksIndexRouteImport } from "./routes/_authenticated/tasks/index"
import { Route as AuthenticatedTasksSubtypeRouteImport } from "./routes/_authenticated/tasks/$subtype"
import { Route as AuthenticatedChainsChainNameIndexRouteImport } from "./routes/_authenticated/chains/$chainName.index"
import { Route as AuthenticatedChainsChainNameEditRouteImport } from "./routes/_authenticated/chains/$chainName.edit"
import { Route as AuthenticatedHardwareDevicesIndexRouteImport } from "./routes/_authenticated/hardware/devices/index"
import { Route as AuthenticatedHardwareFirmwareIndexRouteImport } from "./routes/_authenticated/hardware/firmware/index"
import { Route as AuthenticatedHardwareFirmwareFirmwareIdRouteImport } from "./routes/_authenticated/hardware/firmware/$firmwareId"
import { Route as AuthenticatedIamGroupsIndexRouteImport } from "./routes/_authenticated/iam/groups/index"
import { Route as AuthenticatedIamGroupsGroupNameRouteImport } from "./routes/_authenticated/iam/groups/$groupName"
import { Route as AuthenticatedIamPermissionsIndexRouteImport } from "./routes/_authenticated/iam/permissions/index"
import { Route as AuthenticatedIamSsoIndexRouteImport } from "./routes/_authenticated/iam/sso/index"
import { Route as AuthenticatedIamSsoRealmIdRouteImport } from "./routes/_authenticated/iam/sso/$realmId"
import { Route as AuthenticatedIamUsersIndexRouteImport } from "./routes/_authenticated/iam/users/index"
import { Route as AuthenticatedIamUsersPublicIdRouteImport } from "./routes/_authenticated/iam/users/$publicId"
import { Route as AuthenticatedIamVendorsIndexRouteImport } from "./routes/_authenticated/iam/vendors/index"
import { Route as AuthenticatedIamVendorsVendorNameRouteImport } from "./routes/_authenticated/iam/vendors/$vendorName"
import { Route as AuthenticatedIngressImportsIndexRouteImport } from "./routes/_authenticated/ingress/imports/index"
import { Route as AuthenticatedIngressProductImagesIndexRouteImport } from "./routes/_authenticated/ingress/product-images/index"
import { Route as AuthenticatedIngressTransformationsIndexRouteImport } from "./routes/_authenticated/ingress/transformations/index"
import { Route as AuthenticatedIngressTransformationsTransformationIdRouteImport } from "./routes/_authenticated/ingress/transformations/$transformationId"
import { Route as AuthenticatedOctoRulesIndexRouteImport } from "./routes/_authenticated/octo/rules/index"
import { Route as AuthenticatedOctoRulesRuleIdRouteImport } from "./routes/_authenticated/octo/rules/$ruleId"
import { Route as AuthenticatedOctoVisualizerIndexRouteImport } from "./routes/_authenticated/octo/visualizer/index"
import { Route as AuthenticatedStoresStoreNameIndexRouteImport } from "./routes/_authenticated/stores/$storeName.index"
import { Route as AuthenticatedStoresStoreNameEditRouteImport } from "./routes/_authenticated/stores/$storeName.edit"
import { Route as AuthenticatedTasksSubtypeIndexRouteImport } from "./routes/_authenticated/tasks/$subtype.index"
import { Route as AuthenticatedTasksSubtypeEditRouteImport } from "./routes/_authenticated/tasks/$subtype.edit"
import { Route as AuthenticatedChainsCompareChainNameAChainNameBRouteImport } from "./routes/_authenticated/chains/compare.$chainNameA.$chainNameB"
import { Route as AuthenticatedIamUsersPublicIdIndexRouteImport } from "./routes/_authenticated/iam/users/$publicId.index"
import { Route as AuthenticatedIamUsersPublicIdEditRouteImport } from "./routes/_authenticated/iam/users/$publicId.edit"
import { Route as AuthenticatedOctoRulesRuleIdIndexRouteImport } from "./routes/_authenticated/octo/rules/$ruleId.index"
import { Route as AuthenticatedOctoRulesRuleIdEditRouteImport } from "./routes/_authenticated/octo/rules/$ruleId.edit"
import { Route as AuthenticatedStoresCompareStoreNameAStoreNameBRouteImport } from "./routes/_authenticated/stores/compare.$storeNameA.$storeNameB"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApprovalsIndexRoute =
  AuthenticatedApprovalsIndexRouteImport.update({
    id: "/approvals/",
    path: "/approvals/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChainsIndexRoute =
  AuthenticatedChainsIndexRouteImport.update({
    id: "/chains/",
    path: "/chains/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChainsChainNameRoute =
  AuthenticatedChainsChainNameRouteImport.update({
    id: "/chains/$chainName",
    path: "/chains/$chainName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: "/home/",
  path: "/home/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: "/profile/",
    path: "/profile/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSettingNameRoute =
  AuthenticatedSettingsSettingNameRouteImport.update({
    id: "/settings/$settingName",
    path: "/settings/$settingName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShowcaseIndexRoute =
  AuthenticatedShowcaseIndexRouteImport.update({
    id: "/showcase/",
    path: "/showcase/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoresIndexRoute =
  AuthenticatedStoresIndexRouteImport.update({
    id: "/stores/",
    path: "/stores/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoresStoreNameRoute =
  AuthenticatedStoresStoreNameRouteImport.update({
    id: "/stores/$storeName",
    path: "/stores/$storeName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: "/tasks/",
  path: "/tasks/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksSubtypeRoute =
  AuthenticatedTasksSubtypeRouteImport.update({
    id: "/tasks/$subtype",
    path: "/tasks/$subtype",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChainsChainNameIndexRoute =
  AuthenticatedChainsChainNameIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedChainsChainNameRoute,
  } as any)
const AuthenticatedChainsChainNameEditRoute =
  AuthenticatedChainsChainNameEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedChainsChainNameRoute,
  } as any)
const AuthenticatedHardwareDevicesIndexRoute =
  AuthenticatedHardwareDevicesIndexRouteImport.update({
    id: "/hardware/devices/",
    path: "/hardware/devices/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHardwareFirmwareIndexRoute =
  AuthenticatedHardwareFirmwareIndexRouteImport.update({
    id: "/hardware/firmware/",
    path: "/hardware/firmware/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHardwareFirmwareFirmwareIdRoute =
  AuthenticatedHardwareFirmwareFirmwareIdRouteImport.update({
    id: "/hardware/firmware/$firmwareId",
    path: "/hardware/firmware/$firmwareId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamGroupsIndexRoute =
  AuthenticatedIamGroupsIndexRouteImport.update({
    id: "/iam/groups/",
    path: "/iam/groups/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamGroupsGroupNameRoute =
  AuthenticatedIamGroupsGroupNameRouteImport.update({
    id: "/iam/groups/$groupName",
    path: "/iam/groups/$groupName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamPermissionsIndexRoute =
  AuthenticatedIamPermissionsIndexRouteImport.update({
    id: "/iam/permissions/",
    path: "/iam/permissions/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamSsoIndexRoute =
  AuthenticatedIamSsoIndexRouteImport.update({
    id: "/iam/sso/",
    path: "/iam/sso/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamSsoRealmIdRoute =
  AuthenticatedIamSsoRealmIdRouteImport.update({
    id: "/iam/sso/$realmId",
    path: "/iam/sso/$realmId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamUsersIndexRoute =
  AuthenticatedIamUsersIndexRouteImport.update({
    id: "/iam/users/",
    path: "/iam/users/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamUsersPublicIdRoute =
  AuthenticatedIamUsersPublicIdRouteImport.update({
    id: "/iam/users/$publicId",
    path: "/iam/users/$publicId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamVendorsIndexRoute =
  AuthenticatedIamVendorsIndexRouteImport.update({
    id: "/iam/vendors/",
    path: "/iam/vendors/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamVendorsVendorNameRoute =
  AuthenticatedIamVendorsVendorNameRouteImport.update({
    id: "/iam/vendors/$vendorName",
    path: "/iam/vendors/$vendorName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIngressImportsIndexRoute =
  AuthenticatedIngressImportsIndexRouteImport.update({
    id: "/ingress/imports/",
    path: "/ingress/imports/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIngressProductImagesIndexRoute =
  AuthenticatedIngressProductImagesIndexRouteImport.update({
    id: "/ingress/product-images/",
    path: "/ingress/product-images/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIngressTransformationsIndexRoute =
  AuthenticatedIngressTransformationsIndexRouteImport.update({
    id: "/ingress/transformations/",
    path: "/ingress/transformations/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIngressTransformationsTransformationIdRoute =
  AuthenticatedIngressTransformationsTransformationIdRouteImport.update({
    id: "/ingress/transformations/$transformationId",
    path: "/ingress/transformations/$transformationId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOctoRulesIndexRoute =
  AuthenticatedOctoRulesIndexRouteImport.update({
    id: "/octo/rules/",
    path: "/octo/rules/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOctoRulesRuleIdRoute =
  AuthenticatedOctoRulesRuleIdRouteImport.update({
    id: "/octo/rules/$ruleId",
    path: "/octo/rules/$ruleId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOctoVisualizerIndexRoute =
  AuthenticatedOctoVisualizerIndexRouteImport.update({
    id: "/octo/visualizer/",
    path: "/octo/visualizer/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoresStoreNameIndexRoute =
  AuthenticatedStoresStoreNameIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedStoresStoreNameRoute,
  } as any)
const AuthenticatedStoresStoreNameEditRoute =
  AuthenticatedStoresStoreNameEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedStoresStoreNameRoute,
  } as any)
const AuthenticatedTasksSubtypeIndexRoute =
  AuthenticatedTasksSubtypeIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedTasksSubtypeRoute,
  } as any)
const AuthenticatedTasksSubtypeEditRoute =
  AuthenticatedTasksSubtypeEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedTasksSubtypeRoute,
  } as any)
const AuthenticatedChainsCompareChainNameAChainNameBRoute =
  AuthenticatedChainsCompareChainNameAChainNameBRouteImport.update({
    id: "/chains/compare/$chainNameA/$chainNameB",
    path: "/chains/compare/$chainNameA/$chainNameB",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIamUsersPublicIdIndexRoute =
  AuthenticatedIamUsersPublicIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedIamUsersPublicIdRoute,
  } as any)
const AuthenticatedIamUsersPublicIdEditRoute =
  AuthenticatedIamUsersPublicIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedIamUsersPublicIdRoute,
  } as any)
const AuthenticatedOctoRulesRuleIdIndexRoute =
  AuthenticatedOctoRulesRuleIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOctoRulesRuleIdRoute,
  } as any)
const AuthenticatedOctoRulesRuleIdEditRoute =
  AuthenticatedOctoRulesRuleIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedOctoRulesRuleIdRoute,
  } as any)
const AuthenticatedStoresCompareStoreNameAStoreNameBRoute =
  AuthenticatedStoresCompareStoreNameAStoreNameBRouteImport.update({
    id: "/stores/compare/$storeNameA/$storeNameB",
    path: "/stores/compare/$storeNameA/$storeNameB",
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/$": typeof AuthenticatedSplatRoute
  "/chains/$chainName": typeof AuthenticatedChainsChainNameRouteWithChildren
  "/settings/$settingName": typeof AuthenticatedSettingsSettingNameRoute
  "/stores/$storeName": typeof AuthenticatedStoresStoreNameRouteWithChildren
  "/tasks/$subtype": typeof AuthenticatedTasksSubtypeRouteWithChildren
  "/approvals/": typeof AuthenticatedApprovalsIndexRoute
  "/chains/": typeof AuthenticatedChainsIndexRoute
  "/home/": typeof AuthenticatedHomeIndexRoute
  "/profile/": typeof AuthenticatedProfileIndexRoute
  "/settings/": typeof AuthenticatedSettingsIndexRoute
  "/showcase/": typeof AuthenticatedShowcaseIndexRoute
  "/stores/": typeof AuthenticatedStoresIndexRoute
  "/tasks/": typeof AuthenticatedTasksIndexRoute
  "/chains/$chainName/edit": typeof AuthenticatedChainsChainNameEditRoute
  "/hardware/firmware/$firmwareId": typeof AuthenticatedHardwareFirmwareFirmwareIdRoute
  "/iam/groups/$groupName": typeof AuthenticatedIamGroupsGroupNameRoute
  "/iam/sso/$realmId": typeof AuthenticatedIamSsoRealmIdRoute
  "/iam/users/$publicId": typeof AuthenticatedIamUsersPublicIdRouteWithChildren
  "/iam/vendors/$vendorName": typeof AuthenticatedIamVendorsVendorNameRoute
  "/ingress/transformations/$transformationId": typeof AuthenticatedIngressTransformationsTransformationIdRoute
  "/octo/rules/$ruleId": typeof AuthenticatedOctoRulesRuleIdRouteWithChildren
  "/stores/$storeName/edit": typeof AuthenticatedStoresStoreNameEditRoute
  "/tasks/$subtype/edit": typeof AuthenticatedTasksSubtypeEditRoute
  "/chains/$chainName/": typeof AuthenticatedChainsChainNameIndexRoute
  "/hardware/devices/": typeof AuthenticatedHardwareDevicesIndexRoute
  "/hardware/firmware/": typeof AuthenticatedHardwareFirmwareIndexRoute
  "/iam/groups/": typeof AuthenticatedIamGroupsIndexRoute
  "/iam/permissions/": typeof AuthenticatedIamPermissionsIndexRoute
  "/iam/sso/": typeof AuthenticatedIamSsoIndexRoute
  "/iam/users/": typeof AuthenticatedIamUsersIndexRoute
  "/iam/vendors/": typeof AuthenticatedIamVendorsIndexRoute
  "/ingress/imports/": typeof AuthenticatedIngressImportsIndexRoute
  "/ingress/product-images/": typeof AuthenticatedIngressProductImagesIndexRoute
  "/ingress/transformations/": typeof AuthenticatedIngressTransformationsIndexRoute
  "/octo/rules/": typeof AuthenticatedOctoRulesIndexRoute
  "/octo/visualizer/": typeof AuthenticatedOctoVisualizerIndexRoute
  "/stores/$storeName/": typeof AuthenticatedStoresStoreNameIndexRoute
  "/tasks/$subtype/": typeof AuthenticatedTasksSubtypeIndexRoute
  "/chains/compare/$chainNameA/$chainNameB": typeof AuthenticatedChainsCompareChainNameAChainNameBRoute
  "/iam/users/$publicId/edit": typeof AuthenticatedIamUsersPublicIdEditRoute
  "/octo/rules/$ruleId/edit": typeof AuthenticatedOctoRulesRuleIdEditRoute
  "/stores/compare/$storeNameA/$storeNameB": typeof AuthenticatedStoresCompareStoreNameAStoreNameBRoute
  "/iam/users/$publicId/": typeof AuthenticatedIamUsersPublicIdIndexRoute
  "/octo/rules/$ruleId/": typeof AuthenticatedOctoRulesRuleIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/$": typeof AuthenticatedSplatRoute
  "/settings/$settingName": typeof AuthenticatedSettingsSettingNameRoute
  "/approvals": typeof AuthenticatedApprovalsIndexRoute
  "/chains": typeof AuthenticatedChainsIndexRoute
  "/home": typeof AuthenticatedHomeIndexRoute
  "/profile": typeof AuthenticatedProfileIndexRoute
  "/settings": typeof AuthenticatedSettingsIndexRoute
  "/showcase": typeof AuthenticatedShowcaseIndexRoute
  "/stores": typeof AuthenticatedStoresIndexRoute
  "/tasks": typeof AuthenticatedTasksIndexRoute
  "/chains/$chainName/edit": typeof AuthenticatedChainsChainNameEditRoute
  "/hardware/firmware/$firmwareId": typeof AuthenticatedHardwareFirmwareFirmwareIdRoute
  "/iam/groups/$groupName": typeof AuthenticatedIamGroupsGroupNameRoute
  "/iam/sso/$realmId": typeof AuthenticatedIamSsoRealmIdRoute
  "/iam/vendors/$vendorName": typeof AuthenticatedIamVendorsVendorNameRoute
  "/ingress/transformations/$transformationId": typeof AuthenticatedIngressTransformationsTransformationIdRoute
  "/stores/$storeName/edit": typeof AuthenticatedStoresStoreNameEditRoute
  "/tasks/$subtype/edit": typeof AuthenticatedTasksSubtypeEditRoute
  "/chains/$chainName": typeof AuthenticatedChainsChainNameIndexRoute
  "/hardware/devices": typeof AuthenticatedHardwareDevicesIndexRoute
  "/hardware/firmware": typeof AuthenticatedHardwareFirmwareIndexRoute
  "/iam/groups": typeof AuthenticatedIamGroupsIndexRoute
  "/iam/permissions": typeof AuthenticatedIamPermissionsIndexRoute
  "/iam/sso": typeof AuthenticatedIamSsoIndexRoute
  "/iam/users": typeof AuthenticatedIamUsersIndexRoute
  "/iam/vendors": typeof AuthenticatedIamVendorsIndexRoute
  "/ingress/imports": typeof AuthenticatedIngressImportsIndexRoute
  "/ingress/product-images": typeof AuthenticatedIngressProductImagesIndexRoute
  "/ingress/transformations": typeof AuthenticatedIngressTransformationsIndexRoute
  "/octo/rules": typeof AuthenticatedOctoRulesIndexRoute
  "/octo/visualizer": typeof AuthenticatedOctoVisualizerIndexRoute
  "/stores/$storeName": typeof AuthenticatedStoresStoreNameIndexRoute
  "/tasks/$subtype": typeof AuthenticatedTasksSubtypeIndexRoute
  "/chains/compare/$chainNameA/$chainNameB": typeof AuthenticatedChainsCompareChainNameAChainNameBRoute
  "/iam/users/$publicId/edit": typeof AuthenticatedIamUsersPublicIdEditRoute
  "/octo/rules/$ruleId/edit": typeof AuthenticatedOctoRulesRuleIdEditRoute
  "/stores/compare/$storeNameA/$storeNameB": typeof AuthenticatedStoresCompareStoreNameAStoreNameBRoute
  "/iam/users/$publicId": typeof AuthenticatedIamUsersPublicIdIndexRoute
  "/octo/rules/$ruleId": typeof AuthenticatedOctoRulesRuleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/login": typeof LoginRoute
  "/_authenticated/$": typeof AuthenticatedSplatRoute
  "/_authenticated/chains/$chainName": typeof AuthenticatedChainsChainNameRouteWithChildren
  "/_authenticated/settings/$settingName": typeof AuthenticatedSettingsSettingNameRoute
  "/_authenticated/stores/$storeName": typeof AuthenticatedStoresStoreNameRouteWithChildren
  "/_authenticated/tasks/$subtype": typeof AuthenticatedTasksSubtypeRouteWithChildren
  "/_authenticated/approvals/": typeof AuthenticatedApprovalsIndexRoute
  "/_authenticated/chains/": typeof AuthenticatedChainsIndexRoute
  "/_authenticated/home/": typeof AuthenticatedHomeIndexRoute
  "/_authenticated/profile/": typeof AuthenticatedProfileIndexRoute
  "/_authenticated/settings/": typeof AuthenticatedSettingsIndexRoute
  "/_authenticated/showcase/": typeof AuthenticatedShowcaseIndexRoute
  "/_authenticated/stores/": typeof AuthenticatedStoresIndexRoute
  "/_authenticated/tasks/": typeof AuthenticatedTasksIndexRoute
  "/_authenticated/chains/$chainName/edit": typeof AuthenticatedChainsChainNameEditRoute
  "/_authenticated/hardware/firmware/$firmwareId": typeof AuthenticatedHardwareFirmwareFirmwareIdRoute
  "/_authenticated/iam/groups/$groupName": typeof AuthenticatedIamGroupsGroupNameRoute
  "/_authenticated/iam/sso/$realmId": typeof AuthenticatedIamSsoRealmIdRoute
  "/_authenticated/iam/users/$publicId": typeof AuthenticatedIamUsersPublicIdRouteWithChildren
  "/_authenticated/iam/vendors/$vendorName": typeof AuthenticatedIamVendorsVendorNameRoute
  "/_authenticated/ingress/transformations/$transformationId": typeof AuthenticatedIngressTransformationsTransformationIdRoute
  "/_authenticated/octo/rules/$ruleId": typeof AuthenticatedOctoRulesRuleIdRouteWithChildren
  "/_authenticated/stores/$storeName/edit": typeof AuthenticatedStoresStoreNameEditRoute
  "/_authenticated/tasks/$subtype/edit": typeof AuthenticatedTasksSubtypeEditRoute
  "/_authenticated/chains/$chainName/": typeof AuthenticatedChainsChainNameIndexRoute
  "/_authenticated/hardware/devices/": typeof AuthenticatedHardwareDevicesIndexRoute
  "/_authenticated/hardware/firmware/": typeof AuthenticatedHardwareFirmwareIndexRoute
  "/_authenticated/iam/groups/": typeof AuthenticatedIamGroupsIndexRoute
  "/_authenticated/iam/permissions/": typeof AuthenticatedIamPermissionsIndexRoute
  "/_authenticated/iam/sso/": typeof AuthenticatedIamSsoIndexRoute
  "/_authenticated/iam/users/": typeof AuthenticatedIamUsersIndexRoute
  "/_authenticated/iam/vendors/": typeof AuthenticatedIamVendorsIndexRoute
  "/_authenticated/ingress/imports/": typeof AuthenticatedIngressImportsIndexRoute
  "/_authenticated/ingress/product-images/": typeof AuthenticatedIngressProductImagesIndexRoute
  "/_authenticated/ingress/transformations/": typeof AuthenticatedIngressTransformationsIndexRoute
  "/_authenticated/octo/rules/": typeof AuthenticatedOctoRulesIndexRoute
  "/_authenticated/octo/visualizer/": typeof AuthenticatedOctoVisualizerIndexRoute
  "/_authenticated/stores/$storeName/": typeof AuthenticatedStoresStoreNameIndexRoute
  "/_authenticated/tasks/$subtype/": typeof AuthenticatedTasksSubtypeIndexRoute
  "/_authenticated/chains/compare/$chainNameA/$chainNameB": typeof AuthenticatedChainsCompareChainNameAChainNameBRoute
  "/_authenticated/iam/users/$publicId/edit": typeof AuthenticatedIamUsersPublicIdEditRoute
  "/_authenticated/octo/rules/$ruleId/edit": typeof AuthenticatedOctoRulesRuleIdEditRoute
  "/_authenticated/stores/compare/$storeNameA/$storeNameB": typeof AuthenticatedStoresCompareStoreNameAStoreNameBRoute
  "/_authenticated/iam/users/$publicId/": typeof AuthenticatedIamUsersPublicIdIndexRoute
  "/_authenticated/octo/rules/$ruleId/": typeof AuthenticatedOctoRulesRuleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/$"
    | "/chains/$chainName"
    | "/settings/$settingName"
    | "/stores/$storeName"
    | "/tasks/$subtype"
    | "/approvals/"
    | "/chains/"
    | "/home/"
    | "/profile/"
    | "/settings/"
    | "/showcase/"
    | "/stores/"
    | "/tasks/"
    | "/chains/$chainName/edit"
    | "/hardware/firmware/$firmwareId"
    | "/iam/groups/$groupName"
    | "/iam/sso/$realmId"
    | "/iam/users/$publicId"
    | "/iam/vendors/$vendorName"
    | "/ingress/transformations/$transformationId"
    | "/octo/rules/$ruleId"
    | "/stores/$storeName/edit"
    | "/tasks/$subtype/edit"
    | "/chains/$chainName/"
    | "/hardware/devices/"
    | "/hardware/firmware/"
    | "/iam/groups/"
    | "/iam/permissions/"
    | "/iam/sso/"
    | "/iam/users/"
    | "/iam/vendors/"
    | "/ingress/imports/"
    | "/ingress/product-images/"
    | "/ingress/transformations/"
    | "/octo/rules/"
    | "/octo/visualizer/"
    | "/stores/$storeName/"
    | "/tasks/$subtype/"
    | "/chains/compare/$chainNameA/$chainNameB"
    | "/iam/users/$publicId/edit"
    | "/octo/rules/$ruleId/edit"
    | "/stores/compare/$storeNameA/$storeNameB"
    | "/iam/users/$publicId/"
    | "/octo/rules/$ruleId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/$"
    | "/settings/$settingName"
    | "/approvals"
    | "/chains"
    | "/home"
    | "/profile"
    | "/settings"
    | "/showcase"
    | "/stores"
    | "/tasks"
    | "/chains/$chainName/edit"
    | "/hardware/firmware/$firmwareId"
    | "/iam/groups/$groupName"
    | "/iam/sso/$realmId"
    | "/iam/vendors/$vendorName"
    | "/ingress/transformations/$transformationId"
    | "/stores/$storeName/edit"
    | "/tasks/$subtype/edit"
    | "/chains/$chainName"
    | "/hardware/devices"
    | "/hardware/firmware"
    | "/iam/groups"
    | "/iam/permissions"
    | "/iam/sso"
    | "/iam/users"
    | "/iam/vendors"
    | "/ingress/imports"
    | "/ingress/product-images"
    | "/ingress/transformations"
    | "/octo/rules"
    | "/octo/visualizer"
    | "/stores/$storeName"
    | "/tasks/$subtype"
    | "/chains/compare/$chainNameA/$chainNameB"
    | "/iam/users/$publicId/edit"
    | "/octo/rules/$ruleId/edit"
    | "/stores/compare/$storeNameA/$storeNameB"
    | "/iam/users/$publicId"
    | "/octo/rules/$ruleId"
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/login"
    | "/_authenticated/$"
    | "/_authenticated/chains/$chainName"
    | "/_authenticated/settings/$settingName"
    | "/_authenticated/stores/$storeName"
    | "/_authenticated/tasks/$subtype"
    | "/_authenticated/approvals/"
    | "/_authenticated/chains/"
    | "/_authenticated/home/"
    | "/_authenticated/profile/"
    | "/_authenticated/settings/"
    | "/_authenticated/showcase/"
    | "/_authenticated/stores/"
    | "/_authenticated/tasks/"
    | "/_authenticated/chains/$chainName/edit"
    | "/_authenticated/hardware/firmware/$firmwareId"
    | "/_authenticated/iam/groups/$groupName"
    | "/_authenticated/iam/sso/$realmId"
    | "/_authenticated/iam/users/$publicId"
    | "/_authenticated/iam/vendors/$vendorName"
    | "/_authenticated/ingress/transformations/$transformationId"
    | "/_authenticated/octo/rules/$ruleId"
    | "/_authenticated/stores/$storeName/edit"
    | "/_authenticated/tasks/$subtype/edit"
    | "/_authenticated/chains/$chainName/"
    | "/_authenticated/hardware/devices/"
    | "/_authenticated/hardware/firmware/"
    | "/_authenticated/iam/groups/"
    | "/_authenticated/iam/permissions/"
    | "/_authenticated/iam/sso/"
    | "/_authenticated/iam/users/"
    | "/_authenticated/iam/vendors/"
    | "/_authenticated/ingress/imports/"
    | "/_authenticated/ingress/product-images/"
    | "/_authenticated/ingress/transformations/"
    | "/_authenticated/octo/rules/"
    | "/_authenticated/octo/visualizer/"
    | "/_authenticated/stores/$storeName/"
    | "/_authenticated/tasks/$subtype/"
    | "/_authenticated/chains/compare/$chainNameA/$chainNameB"
    | "/_authenticated/iam/users/$publicId/edit"
    | "/_authenticated/octo/rules/$ruleId/edit"
    | "/_authenticated/stores/compare/$storeNameA/$storeNameB"
    | "/_authenticated/iam/users/$publicId/"
    | "/_authenticated/octo/rules/$ruleId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/$": {
      id: "/_authenticated/$"
      path: "/$"
      fullPath: "/$"
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/approvals/": {
      id: "/_authenticated/approvals/"
      path: "/approvals"
      fullPath: "/approvals/"
      preLoaderRoute: typeof AuthenticatedApprovalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/chains/": {
      id: "/_authenticated/chains/"
      path: "/chains"
      fullPath: "/chains/"
      preLoaderRoute: typeof AuthenticatedChainsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/chains/$chainName": {
      id: "/_authenticated/chains/$chainName"
      path: "/chains/$chainName"
      fullPath: "/chains/$chainName"
      preLoaderRoute: typeof AuthenticatedChainsChainNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/home/": {
      id: "/_authenticated/home/"
      path: "/home"
      fullPath: "/home/"
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/profile/": {
      id: "/_authenticated/profile/"
      path: "/profile"
      fullPath: "/profile/"
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/": {
      id: "/_authenticated/settings/"
      path: "/settings"
      fullPath: "/settings/"
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings/$settingName": {
      id: "/_authenticated/settings/$settingName"
      path: "/settings/$settingName"
      fullPath: "/settings/$settingName"
      preLoaderRoute: typeof AuthenticatedSettingsSettingNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/showcase/": {
      id: "/_authenticated/showcase/"
      path: "/showcase"
      fullPath: "/showcase/"
      preLoaderRoute: typeof AuthenticatedShowcaseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/stores/": {
      id: "/_authenticated/stores/"
      path: "/stores"
      fullPath: "/stores/"
      preLoaderRoute: typeof AuthenticatedStoresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/stores/$storeName": {
      id: "/_authenticated/stores/$storeName"
      path: "/stores/$storeName"
      fullPath: "/stores/$storeName"
      preLoaderRoute: typeof AuthenticatedStoresStoreNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/tasks/": {
      id: "/_authenticated/tasks/"
      path: "/tasks"
      fullPath: "/tasks/"
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/tasks/$subtype": {
      id: "/_authenticated/tasks/$subtype"
      path: "/tasks/$subtype"
      fullPath: "/tasks/$subtype"
      preLoaderRoute: typeof AuthenticatedTasksSubtypeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/chains/$chainName/": {
      id: "/_authenticated/chains/$chainName/"
      path: "/"
      fullPath: "/chains/$chainName/"
      preLoaderRoute: typeof AuthenticatedChainsChainNameIndexRouteImport
      parentRoute: typeof AuthenticatedChainsChainNameRoute
    }
    "/_authenticated/chains/$chainName/edit": {
      id: "/_authenticated/chains/$chainName/edit"
      path: "/edit"
      fullPath: "/chains/$chainName/edit"
      preLoaderRoute: typeof AuthenticatedChainsChainNameEditRouteImport
      parentRoute: typeof AuthenticatedChainsChainNameRoute
    }
    "/_authenticated/hardware/devices/": {
      id: "/_authenticated/hardware/devices/"
      path: "/hardware/devices"
      fullPath: "/hardware/devices/"
      preLoaderRoute: typeof AuthenticatedHardwareDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/hardware/firmware/": {
      id: "/_authenticated/hardware/firmware/"
      path: "/hardware/firmware"
      fullPath: "/hardware/firmware/"
      preLoaderRoute: typeof AuthenticatedHardwareFirmwareIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/hardware/firmware/$firmwareId": {
      id: "/_authenticated/hardware/firmware/$firmwareId"
      path: "/hardware/firmware/$firmwareId"
      fullPath: "/hardware/firmware/$firmwareId"
      preLoaderRoute: typeof AuthenticatedHardwareFirmwareFirmwareIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/groups/": {
      id: "/_authenticated/iam/groups/"
      path: "/iam/groups"
      fullPath: "/iam/groups/"
      preLoaderRoute: typeof AuthenticatedIamGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/groups/$groupName": {
      id: "/_authenticated/iam/groups/$groupName"
      path: "/iam/groups/$groupName"
      fullPath: "/iam/groups/$groupName"
      preLoaderRoute: typeof AuthenticatedIamGroupsGroupNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/permissions/": {
      id: "/_authenticated/iam/permissions/"
      path: "/iam/permissions"
      fullPath: "/iam/permissions/"
      preLoaderRoute: typeof AuthenticatedIamPermissionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/sso/": {
      id: "/_authenticated/iam/sso/"
      path: "/iam/sso"
      fullPath: "/iam/sso/"
      preLoaderRoute: typeof AuthenticatedIamSsoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/sso/$realmId": {
      id: "/_authenticated/iam/sso/$realmId"
      path: "/iam/sso/$realmId"
      fullPath: "/iam/sso/$realmId"
      preLoaderRoute: typeof AuthenticatedIamSsoRealmIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/users/": {
      id: "/_authenticated/iam/users/"
      path: "/iam/users"
      fullPath: "/iam/users/"
      preLoaderRoute: typeof AuthenticatedIamUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/users/$publicId": {
      id: "/_authenticated/iam/users/$publicId"
      path: "/iam/users/$publicId"
      fullPath: "/iam/users/$publicId"
      preLoaderRoute: typeof AuthenticatedIamUsersPublicIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/vendors/": {
      id: "/_authenticated/iam/vendors/"
      path: "/iam/vendors"
      fullPath: "/iam/vendors/"
      preLoaderRoute: typeof AuthenticatedIamVendorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/vendors/$vendorName": {
      id: "/_authenticated/iam/vendors/$vendorName"
      path: "/iam/vendors/$vendorName"
      fullPath: "/iam/vendors/$vendorName"
      preLoaderRoute: typeof AuthenticatedIamVendorsVendorNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/ingress/imports/": {
      id: "/_authenticated/ingress/imports/"
      path: "/ingress/imports"
      fullPath: "/ingress/imports/"
      preLoaderRoute: typeof AuthenticatedIngressImportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/ingress/product-images/": {
      id: "/_authenticated/ingress/product-images/"
      path: "/ingress/product-images"
      fullPath: "/ingress/product-images/"
      preLoaderRoute: typeof AuthenticatedIngressProductImagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/ingress/transformations/": {
      id: "/_authenticated/ingress/transformations/"
      path: "/ingress/transformations"
      fullPath: "/ingress/transformations/"
      preLoaderRoute: typeof AuthenticatedIngressTransformationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/ingress/transformations/$transformationId": {
      id: "/_authenticated/ingress/transformations/$transformationId"
      path: "/ingress/transformations/$transformationId"
      fullPath: "/ingress/transformations/$transformationId"
      preLoaderRoute: typeof AuthenticatedIngressTransformationsTransformationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/octo/rules/": {
      id: "/_authenticated/octo/rules/"
      path: "/octo/rules"
      fullPath: "/octo/rules/"
      preLoaderRoute: typeof AuthenticatedOctoRulesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/octo/rules/$ruleId": {
      id: "/_authenticated/octo/rules/$ruleId"
      path: "/octo/rules/$ruleId"
      fullPath: "/octo/rules/$ruleId"
      preLoaderRoute: typeof AuthenticatedOctoRulesRuleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/octo/visualizer/": {
      id: "/_authenticated/octo/visualizer/"
      path: "/octo/visualizer"
      fullPath: "/octo/visualizer/"
      preLoaderRoute: typeof AuthenticatedOctoVisualizerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/stores/$storeName/": {
      id: "/_authenticated/stores/$storeName/"
      path: "/"
      fullPath: "/stores/$storeName/"
      preLoaderRoute: typeof AuthenticatedStoresStoreNameIndexRouteImport
      parentRoute: typeof AuthenticatedStoresStoreNameRoute
    }
    "/_authenticated/stores/$storeName/edit": {
      id: "/_authenticated/stores/$storeName/edit"
      path: "/edit"
      fullPath: "/stores/$storeName/edit"
      preLoaderRoute: typeof AuthenticatedStoresStoreNameEditRouteImport
      parentRoute: typeof AuthenticatedStoresStoreNameRoute
    }
    "/_authenticated/tasks/$subtype/": {
      id: "/_authenticated/tasks/$subtype/"
      path: "/"
      fullPath: "/tasks/$subtype/"
      preLoaderRoute: typeof AuthenticatedTasksSubtypeIndexRouteImport
      parentRoute: typeof AuthenticatedTasksSubtypeRoute
    }
    "/_authenticated/tasks/$subtype/edit": {
      id: "/_authenticated/tasks/$subtype/edit"
      path: "/edit"
      fullPath: "/tasks/$subtype/edit"
      preLoaderRoute: typeof AuthenticatedTasksSubtypeEditRouteImport
      parentRoute: typeof AuthenticatedTasksSubtypeRoute
    }
    "/_authenticated/chains/compare/$chainNameA/$chainNameB": {
      id: "/_authenticated/chains/compare/$chainNameA/$chainNameB"
      path: "/chains/compare/$chainNameA/$chainNameB"
      fullPath: "/chains/compare/$chainNameA/$chainNameB"
      preLoaderRoute: typeof AuthenticatedChainsCompareChainNameAChainNameBRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/iam/users/$publicId/": {
      id: "/_authenticated/iam/users/$publicId/"
      path: "/"
      fullPath: "/iam/users/$publicId/"
      preLoaderRoute: typeof AuthenticatedIamUsersPublicIdIndexRouteImport
      parentRoute: typeof AuthenticatedIamUsersPublicIdRoute
    }
    "/_authenticated/iam/users/$publicId/edit": {
      id: "/_authenticated/iam/users/$publicId/edit"
      path: "/edit"
      fullPath: "/iam/users/$publicId/edit"
      preLoaderRoute: typeof AuthenticatedIamUsersPublicIdEditRouteImport
      parentRoute: typeof AuthenticatedIamUsersPublicIdRoute
    }
    "/_authenticated/octo/rules/$ruleId/": {
      id: "/_authenticated/octo/rules/$ruleId/"
      path: "/"
      fullPath: "/octo/rules/$ruleId/"
      preLoaderRoute: typeof AuthenticatedOctoRulesRuleIdIndexRouteImport
      parentRoute: typeof AuthenticatedOctoRulesRuleIdRoute
    }
    "/_authenticated/octo/rules/$ruleId/edit": {
      id: "/_authenticated/octo/rules/$ruleId/edit"
      path: "/edit"
      fullPath: "/octo/rules/$ruleId/edit"
      preLoaderRoute: typeof AuthenticatedOctoRulesRuleIdEditRouteImport
      parentRoute: typeof AuthenticatedOctoRulesRuleIdRoute
    }
    "/_authenticated/stores/compare/$storeNameA/$storeNameB": {
      id: "/_authenticated/stores/compare/$storeNameA/$storeNameB"
      path: "/stores/compare/$storeNameA/$storeNameB"
      fullPath: "/stores/compare/$storeNameA/$storeNameB"
      preLoaderRoute: typeof AuthenticatedStoresCompareStoreNameAStoreNameBRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedChainsChainNameRouteChildren {
  AuthenticatedChainsChainNameEditRoute: typeof AuthenticatedChainsChainNameEditRoute
  AuthenticatedChainsChainNameIndexRoute: typeof AuthenticatedChainsChainNameIndexRoute
}

const AuthenticatedChainsChainNameRouteChildren: AuthenticatedChainsChainNameRouteChildren =
  {
    AuthenticatedChainsChainNameEditRoute:
      AuthenticatedChainsChainNameEditRoute,
    AuthenticatedChainsChainNameIndexRoute:
      AuthenticatedChainsChainNameIndexRoute,
  }

const AuthenticatedChainsChainNameRouteWithChildren =
  AuthenticatedChainsChainNameRoute._addFileChildren(
    AuthenticatedChainsChainNameRouteChildren,
  )

interface AuthenticatedStoresStoreNameRouteChildren {
  AuthenticatedStoresStoreNameEditRoute: typeof AuthenticatedStoresStoreNameEditRoute
  AuthenticatedStoresStoreNameIndexRoute: typeof AuthenticatedStoresStoreNameIndexRoute
}

const AuthenticatedStoresStoreNameRouteChildren: AuthenticatedStoresStoreNameRouteChildren =
  {
    AuthenticatedStoresStoreNameEditRoute:
      AuthenticatedStoresStoreNameEditRoute,
    AuthenticatedStoresStoreNameIndexRoute:
      AuthenticatedStoresStoreNameIndexRoute,
  }

const AuthenticatedStoresStoreNameRouteWithChildren =
  AuthenticatedStoresStoreNameRoute._addFileChildren(
    AuthenticatedStoresStoreNameRouteChildren,
  )

interface AuthenticatedTasksSubtypeRouteChildren {
  AuthenticatedTasksSubtypeEditRoute: typeof AuthenticatedTasksSubtypeEditRoute
  AuthenticatedTasksSubtypeIndexRoute: typeof AuthenticatedTasksSubtypeIndexRoute
}

const AuthenticatedTasksSubtypeRouteChildren: AuthenticatedTasksSubtypeRouteChildren =
  {
    AuthenticatedTasksSubtypeEditRoute: AuthenticatedTasksSubtypeEditRoute,
    AuthenticatedTasksSubtypeIndexRoute: AuthenticatedTasksSubtypeIndexRoute,
  }

const AuthenticatedTasksSubtypeRouteWithChildren =
  AuthenticatedTasksSubtypeRoute._addFileChildren(
    AuthenticatedTasksSubtypeRouteChildren,
  )

interface AuthenticatedIamUsersPublicIdRouteChildren {
  AuthenticatedIamUsersPublicIdEditRoute: typeof AuthenticatedIamUsersPublicIdEditRoute
  AuthenticatedIamUsersPublicIdIndexRoute: typeof AuthenticatedIamUsersPublicIdIndexRoute
}

const AuthenticatedIamUsersPublicIdRouteChildren: AuthenticatedIamUsersPublicIdRouteChildren =
  {
    AuthenticatedIamUsersPublicIdEditRoute:
      AuthenticatedIamUsersPublicIdEditRoute,
    AuthenticatedIamUsersPublicIdIndexRoute:
      AuthenticatedIamUsersPublicIdIndexRoute,
  }

const AuthenticatedIamUsersPublicIdRouteWithChildren =
  AuthenticatedIamUsersPublicIdRoute._addFileChildren(
    AuthenticatedIamUsersPublicIdRouteChildren,
  )

interface AuthenticatedOctoRulesRuleIdRouteChildren {
  AuthenticatedOctoRulesRuleIdEditRoute: typeof AuthenticatedOctoRulesRuleIdEditRoute
  AuthenticatedOctoRulesRuleIdIndexRoute: typeof AuthenticatedOctoRulesRuleIdIndexRoute
}

const AuthenticatedOctoRulesRuleIdRouteChildren: AuthenticatedOctoRulesRuleIdRouteChildren =
  {
    AuthenticatedOctoRulesRuleIdEditRoute:
      AuthenticatedOctoRulesRuleIdEditRoute,
    AuthenticatedOctoRulesRuleIdIndexRoute:
      AuthenticatedOctoRulesRuleIdIndexRoute,
  }

const AuthenticatedOctoRulesRuleIdRouteWithChildren =
  AuthenticatedOctoRulesRuleIdRoute._addFileChildren(
    AuthenticatedOctoRulesRuleIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedChainsChainNameRoute: typeof AuthenticatedChainsChainNameRouteWithChildren
  AuthenticatedSettingsSettingNameRoute: typeof AuthenticatedSettingsSettingNameRoute
  AuthenticatedStoresStoreNameRoute: typeof AuthenticatedStoresStoreNameRouteWithChildren
  AuthenticatedTasksSubtypeRoute: typeof AuthenticatedTasksSubtypeRouteWithChildren
  AuthenticatedApprovalsIndexRoute: typeof AuthenticatedApprovalsIndexRoute
  AuthenticatedChainsIndexRoute: typeof AuthenticatedChainsIndexRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedShowcaseIndexRoute: typeof AuthenticatedShowcaseIndexRoute
  AuthenticatedStoresIndexRoute: typeof AuthenticatedStoresIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedHardwareFirmwareFirmwareIdRoute: typeof AuthenticatedHardwareFirmwareFirmwareIdRoute
  AuthenticatedIamGroupsGroupNameRoute: typeof AuthenticatedIamGroupsGroupNameRoute
  AuthenticatedIamSsoRealmIdRoute: typeof AuthenticatedIamSsoRealmIdRoute
  AuthenticatedIamUsersPublicIdRoute: typeof AuthenticatedIamUsersPublicIdRouteWithChildren
  AuthenticatedIamVendorsVendorNameRoute: typeof AuthenticatedIamVendorsVendorNameRoute
  AuthenticatedIngressTransformationsTransformationIdRoute: typeof AuthenticatedIngressTransformationsTransformationIdRoute
  AuthenticatedOctoRulesRuleIdRoute: typeof AuthenticatedOctoRulesRuleIdRouteWithChildren
  AuthenticatedHardwareDevicesIndexRoute: typeof AuthenticatedHardwareDevicesIndexRoute
  AuthenticatedHardwareFirmwareIndexRoute: typeof AuthenticatedHardwareFirmwareIndexRoute
  AuthenticatedIamGroupsIndexRoute: typeof AuthenticatedIamGroupsIndexRoute
  AuthenticatedIamPermissionsIndexRoute: typeof AuthenticatedIamPermissionsIndexRoute
  AuthenticatedIamSsoIndexRoute: typeof AuthenticatedIamSsoIndexRoute
  AuthenticatedIamUsersIndexRoute: typeof AuthenticatedIamUsersIndexRoute
  AuthenticatedIamVendorsIndexRoute: typeof AuthenticatedIamVendorsIndexRoute
  AuthenticatedIngressImportsIndexRoute: typeof AuthenticatedIngressImportsIndexRoute
  AuthenticatedIngressProductImagesIndexRoute: typeof AuthenticatedIngressProductImagesIndexRoute
  AuthenticatedIngressTransformationsIndexRoute: typeof AuthenticatedIngressTransformationsIndexRoute
  AuthenticatedOctoRulesIndexRoute: typeof AuthenticatedOctoRulesIndexRoute
  AuthenticatedOctoVisualizerIndexRoute: typeof AuthenticatedOctoVisualizerIndexRoute
  AuthenticatedChainsCompareChainNameAChainNameBRoute: typeof AuthenticatedChainsCompareChainNameAChainNameBRoute
  AuthenticatedStoresCompareStoreNameAStoreNameBRoute: typeof AuthenticatedStoresCompareStoreNameAStoreNameBRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedChainsChainNameRoute:
    AuthenticatedChainsChainNameRouteWithChildren,
  AuthenticatedSettingsSettingNameRoute: AuthenticatedSettingsSettingNameRoute,
  AuthenticatedStoresStoreNameRoute:
    AuthenticatedStoresStoreNameRouteWithChildren,
  AuthenticatedTasksSubtypeRoute: AuthenticatedTasksSubtypeRouteWithChildren,
  AuthenticatedApprovalsIndexRoute: AuthenticatedApprovalsIndexRoute,
  AuthenticatedChainsIndexRoute: AuthenticatedChainsIndexRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedShowcaseIndexRoute: AuthenticatedShowcaseIndexRoute,
  AuthenticatedStoresIndexRoute: AuthenticatedStoresIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedHardwareFirmwareFirmwareIdRoute:
    AuthenticatedHardwareFirmwareFirmwareIdRoute,
  AuthenticatedIamGroupsGroupNameRoute: AuthenticatedIamGroupsGroupNameRoute,
  AuthenticatedIamSsoRealmIdRoute: AuthenticatedIamSsoRealmIdRoute,
  AuthenticatedIamUsersPublicIdRoute:
    AuthenticatedIamUsersPublicIdRouteWithChildren,
  AuthenticatedIamVendorsVendorNameRoute:
    AuthenticatedIamVendorsVendorNameRoute,
  AuthenticatedIngressTransformationsTransformationIdRoute:
    AuthenticatedIngressTransformationsTransformationIdRoute,
  AuthenticatedOctoRulesRuleIdRoute:
    AuthenticatedOctoRulesRuleIdRouteWithChildren,
  AuthenticatedHardwareDevicesIndexRoute:
    AuthenticatedHardwareDevicesIndexRoute,
  AuthenticatedHardwareFirmwareIndexRoute:
    AuthenticatedHardwareFirmwareIndexRoute,
  AuthenticatedIamGroupsIndexRoute: AuthenticatedIamGroupsIndexRoute,
  AuthenticatedIamPermissionsIndexRoute: AuthenticatedIamPermissionsIndexRoute,
  AuthenticatedIamSsoIndexRoute: AuthenticatedIamSsoIndexRoute,
  AuthenticatedIamUsersIndexRoute: AuthenticatedIamUsersIndexRoute,
  AuthenticatedIamVendorsIndexRoute: AuthenticatedIamVendorsIndexRoute,
  AuthenticatedIngressImportsIndexRoute: AuthenticatedIngressImportsIndexRoute,
  AuthenticatedIngressProductImagesIndexRoute:
    AuthenticatedIngressProductImagesIndexRoute,
  AuthenticatedIngressTransformationsIndexRoute:
    AuthenticatedIngressTransformationsIndexRoute,
  AuthenticatedOctoRulesIndexRoute: AuthenticatedOctoRulesIndexRoute,
  AuthenticatedOctoVisualizerIndexRoute: AuthenticatedOctoVisualizerIndexRoute,
  AuthenticatedChainsCompareChainNameAChainNameBRoute:
    AuthenticatedChainsCompareChainNameAChainNameBRoute,
  AuthenticatedStoresCompareStoreNameAStoreNameBRoute:
    AuthenticatedStoresCompareStoreNameAStoreNameBRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
